import { ContactList } from "../../modules/authmethods";
import { PhoneNumberEnrolment } from "../../components/PhoneNumberInput"

export const getContactList = (pneList: PhoneNumberEnrolment | PhoneNumberEnrolment[]): ContactList => 
  _.castArray(pneList).map(pne => ({
    defaultFlag: pne.default,
    label: pne.key,
    phoneNumber: pne.phoneNumber.getNumber().replace(/\D/, "")
  })) as ContactList

export const isRequired = (requiredCredentials: any) => {
  return requiredCredentials.filter((c: any) => c.credentialType === "QUESTION").length > 0
}
